import { useSelector } from 'react-redux';

export const usePermissions = () => {
  const { userPermissions, userRoles } = useSelector(state => state.permissions);

  // Check if user has specific permission
  const hasPermission = (permission) => {
    if (!permission) return true; // If no permission specified, allow access
    if (!userPermissions || userPermissions.length === 0) return false; // No permissions loaded
    return userPermissions.includes(permission);
  };

  // Check if user has any of the specified permissions
  const hasAnyPermission = (permissions) => {
    if (!permissions || permissions.length === 0) return true;
    return permissions.some(permission => userPermissions.includes(permission));
  };

  // Check if user has all of the specified permissions
  const hasAllPermissions = (permissions) => {
    if (!permissions || permissions.length === 0) return true;
    return permissions.every(permission => userPermissions.includes(permission));
  };

  // Check if user has specific role
  const hasRole = (roleName) => {
    if (!roleName) return true;
    return userRoles.some(role => role.role_name_en === roleName);
  };

  // Check if user is super admin
  const isSuperAdmin = () => {
    return hasRole('Super Admin');
  };

  // Get user's role names
  const getUserRoleNames = () => {
    return userRoles.map(role => role.role_name_en);
  };

  // Get permissions for specific module
  const getModulePermissions = (module) => {
    return userPermissions.filter(permission => permission.startsWith(module));
  };

  return {
    userPermissions,
    userRoles,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    hasRole,
    isSuperAdmin,
    getUserRoleNames,
    getModulePermissions
  };
};

export default usePermissions;
